export const initialFilterState = {
    places: [],
    cities: []
}

export const initialSearchState = {
    dateFrom: null,
    dateTo: null,
    placeId: [],
    cityId: [],
    page: 1,
    pageSize: 10,
}

export const initialMediatorState = {
    firstname: '',
    lastname: '',
    phoneNumber: '',
    birthDate: '',
    place: ''
};

export const selectedFiltersInitialState = {
    dateFrom: null,
    dateTo: null,
    type: undefined,
    firstName: null,
    lastName: null,
    page: null,
    pageSize: null
}

export const initialMediatorScoreState = {
    mediatorId: 0,
    score: 0 as string | number,
    type: "",
};

export const updatingMediatorInitialState = {
    id: 0,
    firstname: "",
    lastname: "",
    phoneNumber: "",
    birthDate: "",
    place: {
        id: 0,
        name: "",
        city: "",
    },
};

export const mediatorsViewFilterInitialState = {
    placeId: [],
    firstname: "",
    lastname: "",
    page: 1,
    pageSize: 10,
    birthDate: null,
};